import * as PIXI from 'pixi.js-legacy';

import Base from './Base';
import constants from '../settings/constants';
import {
  selectSceneMargins,
  selectSceneRect,
} from '../state/scene/sceneSelectors';
import store from '../state';
import { selectUserAgent } from '../state/userAgent/userAgentSelectors';

export default class Room extends Base {
  update() {
    const sceneRect = selectSceneRect(store.getState());
    const margins = selectSceneMargins(store.getState());
    const userAgent = selectUserAgent(store.getState());
    if (sceneRect) {
      this.x = sceneRect.x;
      this.y = sceneRect.y;
      this.targetWidth = sceneRect.width;
      this.targetHeight = sceneRect.height;
    }

    this.leftDepth =
      Math.cos(constants.OBLIQUE_ANGLE) * constants.ROOM_DEPTH * 0.29;
    this.bottomDepth =
      Math.sin(constants.OBLIQUE_ANGLE) * constants.ROOM_DEPTH * 0.29;

    this.margins = margins;
    this.isMobile = userAgent && userAgent.isMobile;
    this.isPortrait = userAgent && userAgent.isPortrait;
  }

  draw() {
    this.drawWall();
    this.drawSkirt();
    this.drawFloor();
  }

  drawSkirt() {
    const width = this.getSkirtWidth();

    this.skirt = this.skirt || new PIXI.Graphics();

    const { skirt } = this;

    skirt.clear();
    skirt.beginFill(constants.SKIRT_COLOR);
    skirt.drawRect(0, 0, width, this.getSkirtHeight());
    skirt.endFill();
    skirt.lineStyle(
      constants.SKIRT_EDGE_THICKNESS * this.ratio,
      constants.SKIRT_EDGE_COLOR
    );
    skirt.moveTo(0, 0);
    skirt.lineTo(width, 0);
    skirt.y = this.getSkirtY();
    skirt.x = this.getSkirtX();

    !skirt.parent && this.addChild(skirt);
  }

  getSkirtWidth() {
    return this.currentWall.width;
  }

  getSkirtHeight() {
    return constants.SKIRT_HEIGHT * this.ratio;
  }

  getSkirtY() {
    return (
      this.targetHeight - this.floorHeight - constants.SKIRT_HEIGHT * this.ratio
    );
  }

  getSkirtX() {
    return 0;
  }

  getDefaultWallPoints() {
    return [
      { x: 0, y: 0 },
      { x: this.targetWidth, y: 0 },
      { x: this.targetWidth, y: this.targetHeight },
      { x: 0, y: this.targetHeight },
    ];
  }

  getMaxWallPoints() {
    return [
      { x: 0, y: 0 },
      { x: constants.WALL.width.max * this.ratio, y: 0 },
      {
        x: constants.WALL.width.max * this.ratio,
        y: constants.WALL.height.max * this.ratio,
      },
      { x: 0, y: constants.WALL.height.max * this.ratio },
    ];
  }

  createGradientCanvas({ angle, lightColor, darkColor }) {
    const width = this.targetWidth;
    const height = this.targetHeight;

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');

    const move = (Math.tan((angle / 180) * Math.PI) * height) / 2;

    const grd = ctx.createLinearGradient(
      width / 2 - move,
      0,
      width / 2 + move,
      height
    );
    grd.addColorStop(0, PIXI.utils.hex2string(lightColor));
    grd.addColorStop(1, PIXI.utils.hex2string(darkColor));

    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, width, height);

    return canvas;
  }
}
